export enum RequestStatus
{
    NOT_EXECUTED = 'not-executed',
    PENDING = 'pending',
    CONCLUDED = 'concluded',
    ERROR = 'error'
}
